





























import { Component } from 'vue-property-decorator';
import { AboutBenefitModel, aboutBenefits } from '@web/models/AboutModels';
import HomeSection from '../Home/Section.abstract';

@Component
export default class AboutBenefits extends HomeSection {
  imagesAppeareence = true;

  headersAppearence = true;

  imagesRefs = {
    inspiration: 'inspiration',
    integrity: 'integrity',
    collaboration: 'collaboration',
    innovation: 'innovation',
    simplicity: 'simplicity',
  };

  headersRefs = {
    header: 'header',
  };

  public aboutBenefits: AboutBenefitModel[] = aboutBenefits;
}
